class ODDetailAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordionItems = this.querySelectorAll('.accordion-item');
    this.init()
  }

  init() {
    this.accordionItems.forEach(item => {
      
      const clickTarget = item.querySelector('.accordion-heading-title');
      
      if (!clickTarget) return;
      
      const body = item.querySelector('.accordion-item-body');
      
      clickTarget.addEventListener('click', () => {
        clickTarget.classList.toggle('active');
        if (body) {
          body.classList.toggle('hidden');
        }
      });
    });
  }
}

customElements.define('od-details-accordion', ODDetailAccordion);